import { render, staticRenderFns } from "./MobileOfferCard.vue?vue&type=template&id=2534c2c4"
import script from "./MobileOfferCard.vue?vue&type=script&lang=js"
export * from "./MobileOfferCard.vue?vue&type=script&lang=js"
import style0 from "./MobileOfferCard.vue?vue&type=style&index=0&id=2534c2c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports